import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsContract({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11 2c.83 0 1.5.67 1.5 1.5v3.52A5 5 0 007.42 14H3a1.5 1.5 0 01-1.5-1.5v-9C1.5 2.67 2.17 2 3 2h8zm1 6a4 4 0 110 8 4 4 0 010-8zm-.1 1.65a.2.2 0 00-.08.09l-.67 1.28-1.38.28a.2.2 0 00-.1.32l.96 1.1-.17 1.46a.2.2 0 00.28.2l1.26-.62 1.26.62a.2.2 0 00.29-.2l-.18-1.47.97-1.09a.2.2 0 00-.1-.32l-1.4-.28-.66-1.28a.2.2 0 00-.27-.09zM4.19 5.4h5.64c.38 0 .68-.27.68-.6 0-.33-.3-.6-.68-.6H4.18c-.38 0-.68.27-.68.6 0 .33.3.6.68.6zM4.1 8.2h2.5a.6.6 0 100-1.2H4.1a.6.6 0 100 1.2z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgSettingsContract.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsContract.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsContract svgRef={ref} {...props} />
));
export default ForwardRef;
